import React, { Fragment, FunctionComponent, ReactElement, useState } from 'react';
import { Link, Modal, Button } from '@ds/ui';
import { inkFontTokens, inkSpacingTokens } from '@ds/tokens';
import styled from '@emotion/styled';
import { ConditionalChildren } from 'layouts';

type ModalOnLinkProps = {
    linkText: string;
    linkDataQa?: string;
    headerDataQa?: string;
    contentDataQa?: string;
    modalHeaderTitle: string;
    hideLink?: boolean;
    actionButtonText?: string;
    onActionButtonClick?: () => void;
    actionButtonDataQa?: string;
};

const ModalLinkContainer = styled.div`
    ${inkFontTokens.fontBodyM};
    margin-top: ${inkSpacingTokens.spacingXS};
`;

const ModalOnLink: FunctionComponent<ModalOnLinkProps> = ({
    linkText,
    modalHeaderTitle,
    children,
    linkDataQa,
    headerDataQa,
    contentDataQa,
    hideLink,
    actionButtonText,
    onActionButtonClick,
    actionButtonDataQa
}): ReactElement | null => {
    const [modalVisible, setModalVisible] = useState(false);

    const toggleModalVisible = () => {
        setModalVisible(!modalVisible);
    };

    return (
        <Fragment>
            {true !== hideLink && (
                <ModalLinkContainer>
                    <Link discrete={true} text={linkText} data-qa={linkDataQa} onClick={toggleModalVisible} />
                </ModalLinkContainer>
            )}
            <Modal
                width="xlarge"
                onClose={() => setModalVisible(false)}
                visible={modalVisible}
                closeButton={
                    <div data-qa="modal-close">
                        <Modal.Close onClick={toggleModalVisible} />
                    </div>
                }
            >
                <Modal.Header title={modalHeaderTitle} data-qa={headerDataQa} />

                <Modal.Body>
                    <div data-qa={contentDataQa}>{children}</div>
                </Modal.Body>

                <ConditionalChildren condition={actionButtonText !== undefined}>
                    <Modal.Footer
                        primaryButton={
                            <Button
                                size="small"
                                kind="primary"
                                data-qa={actionButtonDataQa}
                                text={actionButtonText || ''}
                                onClick={onActionButtonClick}
                            />
                        }
                    />
                </ConditionalChildren>
            </Modal>
        </Fragment>
    );
};

export default ModalOnLink;
